
import {
  parseProductFromShopify,
  productExist,
  colorExist,
  metafieldsColorExist,
  metafieldsExist,
  metafieldsLangExist,
} from '~/helpers/shopify/product'
import { parseProducts } from '~/helpers/searchspring/products'
import Carousel from '~/components/carousel/carousel.vue'
import ProductCard from '~/components/product-card/ProductCard'
export default {
  components: {
    Carousel,
    ProductCard,
  },
  inject: ['wording'],
  data() {
    return {
      products: [],
    }
  },
  beforeMount() {
    if (this.wording.carousel_collectionHandle)
      this.fetchProductsByCollectionHandle()
    else this.fetchProductsByInternalTypes()
  },
  methods: {
    async fetchProductsByInternalTypes() {
      try {
        if (
          this.wording.carousel_products &&
          this.wording.carousel_products.length > 0
        ) {
          const { data } =
            await this.$shopify.product.getProductsByInternalType(
              this.wording.carousel_products.map((obj) => obj.internal_type)
            )
          if (data.products.edges.length > 0) {
            data.products.edges.forEach((p) => {
              const product = p.node
              const internalType = product.handle.split('-').pop()
              const { color } = this.wording.carousel_products.find(
                ({ internal_type }) => {
                  return internal_type.toLowerCase() === internalType
                }
              )
              let colors = null
              if (color) {
                colors = [color]
              } else {
                colors = product.options.find((o) => {
                  return o.name === 'Color'
                }).values
              }
              colors.forEach((c) => {
                const { exclusions } = this.wording.carousel_products.find(
                  ({ internal_type }) => {
                    return internal_type.toLowerCase() === internalType
                  }
                )
                if (
                  !exclusions
                    .replace(/\s/g, '')
                    .split(',')
                    .find((exclu) => {
                      return exclu === c
                    })
                ) {
                  if (
                    product &&
                    productExist(product) &&
                    colorExist(product, c) &&
                    metafieldsExist(product) &&
                    metafieldsLangExist(product, this.$i18n.locale) &&
                    metafieldsColorExist(product, c, this.$i18n.locale)
                  ) {
                    this.products.push(
                      parseProductFromShopify(product, this.$i18n.locale, c)
                        .result
                    )
                  }
                }
              })
            })
          }
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Cart - Carrousel',
          level: 'fatal',
          extra: `Page cart - fetchProductsByInternalTypes() fail : ${e}`,
        })
      }
    },
    async fetchProductsByCollectionHandle() {
      try {
        let siteId = null
        if (this.$i18n.locale === 'en-ca')
          siteId = this.$config.SEARCHSPRING_SITE_IDS.EN_CA
        else if (this.$i18n.locale === 'fr-ca')
          siteId = this.$config.SEARCHSPRING_SITE_IDS.FR_CA
        else if (this.$i18n.locale === 'en-eu')
          siteId = this.$config.SEARCHSPRING_SITE_IDS.EN_EU
        else if (this.$i18n.locale === 'fr-eu')
          siteId = this.$config.SEARCHSPRING_SITE_IDS.FR_EU
        else siteId = this.$config.SEARCHSPRING_SITE_IDS.EN_US

        const url = `https://api.searchspring.net/api/search/search.json?siteId=${siteId}&resultsFormat=native&format=json&bgfilter.collection_handle=${this.wording.carousel_collectionHandle}&resultsPerPage=10&page=1`
        const { data } = await this.$axios.get(url)
        if (data && data.results && data.results.length > 0) {
          const { errors, resultProducts } = parseProducts(
            data,
            this.$i18n.locale
          )
          if (errors.length === 0) this.products = resultProducts
          else throw new Error('error searchspring fetch')
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Cart - Carrousel',
          level: 'fatal',
          extra: `Page cart - fetchProductsByCollectionHandle() fail : ${e}`,
        })
      }
    },
  },
}
